export default __webpack_public_path__ + "static/media/awesome-file-alt.8208108d.svg";